import { render, staticRenderFns } from "./Home202312.vue?vue&type=template&id=38206408&scoped=true&"
import script from "./Home202312.vue?vue&type=script&lang=js&"
export * from "./Home202312.vue?vue&type=script&lang=js&"
import style0 from "./Home202312.vue?vue&type=style&index=0&id=38206408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38206408",
  null
  
)

export default component.exports